import { localStrings } from "./localization";

export const getStringByTextKey = (key: string, ...params: any[]): string => {
  let value: any = localStrings;
  const items = key.split(".");

  if (!items.length) return key;

  for (const el of items) {
    if (value?.[el] === undefined) {
      return key; // 찾을 수 없으면 key 반환
    }
    value = value[el];
  }

  if (typeof value !== "string") return key;

  if (params.length) {
    params.forEach((param, idx) => {
      value = value.replace(`{${idx}}`, param);
    });
  }

  return value;
};
